import React from 'react';
import { motion } from 'framer-motion';
import { Activity } from 'lucide-react';
export function PainAgitation() {
  return <section className="bg-brand-gray-light py-16 px-4 sm:px-6 lg:px-8" data-id="element-107">
      <div className="max-w-3xl mx-auto text-center" data-id="element-108">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-center" data-id="element-109">
          <div className="bg-white p-3 rounded-full shadow-sm mb-6" data-id="element-110">
            <Activity className="w-8 h-8 text-brand-purple" data-id="element-111" />
          </div>
          <p className="text-xl sm:text-2xl md:text-3xl font-medium italic text-brand-black leading-relaxed" data-id="element-112">
            "Long hours on your phone, poor posture and daily stress are
            silently damaging your neck. Ignoring it only makes it worse."
          </p>
        </motion.div>
      </div>
    </section>;
}